// Generated by ts-to-zod
import {z} from "zod";
import {
	mantineCssLengthSchema,
	mantineCssStyleRecordSchema,
	mantineFlexWrapSchema,
	mantineStylesApiSchema,
} from "./primitives.zod";
import {mantineSpacingSchema} from "./spacing.zod";

export const mantineGroupPropsSchema = z.strictObject({
	w: mantineCssLengthSchema.optional(),
	h: mantineCssLengthSchema.optional(),
	justify: z.string().optional(),
	align: z.string().optional(),
	gap: mantineSpacingSchema.optional(),
	wrap: mantineFlexWrapSchema.optional(),
	p: mantineSpacingSchema.optional(),
	pt: mantineSpacingSchema.optional(),
	pb: mantineSpacingSchema.optional(),
	mb: mantineSpacingSchema.optional(),
	style: mantineCssStyleRecordSchema.optional(),
	styles: mantineStylesApiSchema.optional(),
});
